var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1512,
    height: 982,
    viewBox: "0 0 1512 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_568_260)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "#7CA7C6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647 335C660.807 335 672 323.807 672 310C672 296.193 660.807 285 647 285C633.193 285 622 296.193 622 310C622 323.807 633.193 335 647 335ZM647 322.5C653.904 322.5 659.5 316.904 659.5 310C659.5 303.096 653.904 297.5 647 297.5C640.096 297.5 634.5 303.096 634.5 310C634.5 316.904 640.096 322.5 647 322.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M633 402C646.807 402 658 390.807 658 377C658 363.193 646.807 352 633 352C619.193 352 608 363.193 608 377C608 390.807 619.193 402 633 402ZM633 389.5C639.904 389.5 645.5 383.904 645.5 377C645.5 370.096 639.904 364.5 633 364.5C626.096 364.5 620.5 370.096 620.5 377C620.5 383.904 626.096 389.5 633 389.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1067 456C1080.81 456 1092 444.807 1092 431C1092 417.193 1080.81 406 1067 406C1053.19 406 1042 417.193 1042 431C1042 444.807 1053.19 456 1067 456ZM1067 443.5C1073.9 443.5 1079.5 437.904 1079.5 431C1079.5 424.096 1073.9 418.5 1067 418.5C1060.1 418.5 1054.5 424.096 1054.5 431C1054.5 437.904 1060.1 443.5 1067 443.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M488 768C501.807 768 513 756.807 513 743C513 729.193 501.807 718 488 718C474.193 718 463 729.193 463 743C463 756.807 474.193 768 488 768ZM488 755.5C494.904 755.5 500.5 749.904 500.5 743C500.5 736.096 494.904 730.5 488 730.5C481.096 730.5 475.5 736.096 475.5 743C475.5 749.904 481.096 755.5 488 755.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482 673C495.807 673 507 661.807 507 648C507 634.193 495.807 623 482 623C468.193 623 457 634.193 457 648C457 661.807 468.193 673 482 673ZM482 660.5C488.904 660.5 494.5 654.904 494.5 648C494.5 641.096 488.904 635.5 482 635.5C475.096 635.5 469.5 641.096 469.5 648C469.5 654.904 475.096 660.5 482 660.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429 723C442.807 723 454 711.807 454 698C454 684.193 442.807 673 429 673C415.193 673 404 684.193 404 698C404 711.807 415.193 723 429 723ZM429 710.5C435.904 710.5 441.5 704.904 441.5 698C441.5 691.096 435.904 685.5 429 685.5C422.096 685.5 416.5 691.096 416.5 698C416.5 704.904 422.096 710.5 429 710.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M413 668C426.807 668 438 656.807 438 643C438 629.193 426.807 618 413 618C399.193 618 388 629.193 388 643C388 656.807 399.193 668 413 668ZM413 655.5C419.904 655.5 425.5 649.904 425.5 643C425.5 636.096 419.904 630.5 413 630.5C406.096 630.5 400.5 636.096 400.5 643C400.5 649.904 406.096 655.5 413 655.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432 607C445.807 607 457 595.807 457 582C457 568.193 445.807 557 432 557C418.193 557 407 568.193 407 582C407 595.807 418.193 607 432 607ZM432 594.5C438.904 594.5 444.5 588.904 444.5 582C444.5 575.096 438.904 569.5 432 569.5C425.096 569.5 419.5 575.096 419.5 582C419.5 588.904 425.096 594.5 432 594.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M898 851C911.807 851 923 839.807 923 826C923 812.193 911.807 801 898 801C884.193 801 873 812.193 873 826C873 839.807 884.193 851 898 851ZM898 838.5C904.904 838.5 910.5 832.904 910.5 826C910.5 819.096 904.904 813.5 898 813.5C891.096 813.5 885.5 819.096 885.5 826C885.5 832.904 891.096 838.5 898 838.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1058 113C1071.81 113 1083 101.807 1083 88C1083 74.1929 1071.81 63 1058 63C1044.19 63 1033 74.1929 1033 88C1033 101.807 1044.19 113 1058 113ZM1058 100.5C1064.9 100.5 1070.5 94.9036 1070.5 88C1070.5 81.0964 1064.9 75.5 1058 75.5C1051.1 75.5 1045.5 81.0964 1045.5 88C1045.5 94.9036 1051.1 100.5 1058 100.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M987 94C1000.81 94 1012 82.8071 1012 69C1012 55.1929 1000.81 44 987 44C973.193 44 962 55.1929 962 69C962 82.8071 973.193 94 987 94ZM987 81.5C993.904 81.5 999.5 75.9036 999.5 69C999.5 62.0964 993.904 56.5 987 56.5C980.096 56.5 974.5 62.0964 974.5 69C974.5 75.9036 980.096 81.5 987 81.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M571 428C584.807 428 596 416.807 596 403C596 389.193 584.807 378 571 378C557.193 378 546 389.193 546 403C546 416.807 557.193 428 571 428ZM571 415.5C577.904 415.5 583.5 409.904 583.5 403C583.5 396.096 577.904 390.5 571 390.5C564.096 390.5 558.5 396.096 558.5 403C558.5 409.904 564.096 415.5 571 415.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1001 475C1014.81 475 1026 463.807 1026 450C1026 436.193 1014.81 425 1001 425C987.193 425 976 436.193 976 450C976 463.807 987.193 475 1001 475ZM1001 462.5C1007.9 462.5 1013.5 456.904 1013.5 450C1013.5 443.096 1007.9 437.5 1001 437.5C994.096 437.5 988.5 443.096 988.5 450C988.5 456.904 994.096 462.5 1001 462.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429 789C442.807 789 454 777.807 454 764C454 750.193 442.807 739 429 739C415.193 739 404 750.193 404 764C404 777.807 415.193 789 429 789ZM429 776.5C435.904 776.5 441.5 770.904 441.5 764C441.5 757.096 435.904 751.5 429 751.5C422.096 751.5 416.5 757.096 416.5 764C416.5 770.904 422.096 776.5 429 776.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M825 870C838.807 870 850 858.807 850 845C850 831.193 838.807 820 825 820C811.193 820 800 831.193 800 845C800 858.807 811.193 870 825 870ZM825 857.5C831.904 857.5 837.5 851.904 837.5 845C837.5 838.096 831.904 832.5 825 832.5C818.096 832.5 812.5 838.096 812.5 845C812.5 851.904 818.096 857.5 825 857.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M999 160C1012.81 160 1024 148.807 1024 135C1024 121.193 1012.81 110 999 110C985.193 110 974 121.193 974 135C974 148.807 985.193 160 999 160ZM999 147.5C1005.9 147.5 1011.5 141.904 1011.5 135C1011.5 128.096 1005.9 122.5 999 122.5C992.096 122.5 986.5 128.096 986.5 135C986.5 141.904 992.096 147.5 999 147.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M761 402C774.807 402 786 390.807 786 377C786 363.193 774.807 352 761 352C747.193 352 736 363.193 736 377C736 390.807 747.193 402 761 402ZM761 389.5C767.904 389.5 773.5 383.904 773.5 377C773.5 370.096 767.904 364.5 761 364.5C754.096 364.5 748.5 370.096 748.5 377C748.5 383.904 754.096 389.5 761 389.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762 467C775.807 467 787 455.807 787 442C787 428.193 775.807 417 762 417C748.193 417 737 428.193 737 442C737 455.807 748.193 467 762 467ZM762 454.5C768.904 454.5 774.5 448.904 774.5 442C774.5 435.096 768.904 429.5 762 429.5C755.096 429.5 749.5 435.096 749.5 442C749.5 448.904 755.096 454.5 762 454.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M694 491C707.807 491 719 479.807 719 466C719 452.193 707.807 441 694 441C680.193 441 669 452.193 669 466C669 479.807 680.193 491 694 491ZM694 478.5C700.904 478.5 706.5 472.904 706.5 466C706.5 459.096 700.904 453.5 694 453.5C687.096 453.5 681.5 459.096 681.5 466C681.5 472.904 687.096 478.5 694 478.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M714 553C727.807 553 739 541.807 739 528C739 514.193 727.807 503 714 503C700.193 503 689 514.193 689 528C689 541.807 700.193 553 714 553ZM714 540.5C720.904 540.5 726.5 534.904 726.5 528C726.5 521.096 720.904 515.5 714 515.5C707.096 515.5 701.5 521.096 701.5 528C701.5 534.904 707.096 540.5 714 540.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514 384C527.807 384 539 372.807 539 359C539 345.193 527.807 334 514 334C500.193 334 489 345.193 489 359C489 372.807 500.193 384 514 384ZM514 371.5C520.904 371.5 526.5 365.904 526.5 359C526.5 352.096 520.904 346.5 514 346.5C507.096 346.5 501.5 352.096 501.5 359C501.5 365.904 507.096 371.5 514 371.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119 546C1132.81 546 1144 534.807 1144 521C1144 507.193 1132.81 496 1119 496C1105.19 496 1094 507.193 1094 521C1094 534.807 1105.19 546 1119 546ZM1119 533.5C1125.9 533.5 1131.5 527.904 1131.5 521C1131.5 514.096 1125.9 508.5 1119 508.5C1112.1 508.5 1106.5 514.096 1106.5 521C1106.5 527.904 1112.1 533.5 1119 533.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547 873C560.807 873 572 861.807 572 848C572 834.193 560.807 823 547 823C533.193 823 522 834.193 522 848C522 861.807 533.193 873 547 873ZM547 860.5C553.904 860.5 559.5 854.904 559.5 848C559.5 841.096 553.904 835.5 547 835.5C540.096 835.5 534.5 841.096 534.5 848C534.5 854.904 540.096 860.5 547 860.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946 953C959.807 953 971 941.807 971 928C971 914.193 959.807 903 946 903C932.193 903 921 914.193 921 928C921 941.807 932.193 953 946 953ZM946 940.5C952.904 940.5 958.5 934.904 958.5 928C958.5 921.096 952.904 915.5 946 915.5C939.096 915.5 933.5 921.096 933.5 928C933.5 934.904 939.096 940.5 946 940.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1086 241C1099.81 241 1111 229.807 1111 216C1111 202.193 1099.81 191 1086 191C1072.19 191 1061 202.193 1061 216C1061 229.807 1072.19 241 1086 241ZM1086 228.5C1092.9 228.5 1098.5 222.904 1098.5 216C1098.5 209.096 1092.9 203.5 1086 203.5C1079.1 203.5 1073.5 209.096 1073.5 216C1073.5 222.904 1079.1 228.5 1086 228.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M616 542C629.807 542 641 530.807 641 517C641 503.193 629.807 492 616 492C602.193 492 591 503.193 591 517C591 530.807 602.193 542 616 542ZM616 529.5C622.904 529.5 628.5 523.904 628.5 517C628.5 510.096 622.904 504.5 616 504.5C609.096 504.5 603.5 510.096 603.5 517C603.5 523.904 609.096 529.5 616 529.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441 414C454.807 414 466 402.807 466 389C466 375.193 454.807 364 441 364C427.193 364 416 375.193 416 389C416 402.807 427.193 414 441 414ZM441 401.5C447.904 401.5 453.5 395.904 453.5 389C453.5 382.096 447.904 376.5 441 376.5C434.096 376.5 428.5 382.096 428.5 389C428.5 395.904 434.096 401.5 441 401.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377 442C390.807 442 402 430.807 402 417C402 403.193 390.807 392 377 392C363.193 392 352 403.193 352 417C352 430.807 363.193 442 377 442ZM377 429.5C383.904 429.5 389.5 423.904 389.5 417C389.5 410.096 383.904 404.5 377 404.5C370.096 404.5 364.5 410.096 364.5 417C364.5 423.904 370.096 429.5 377 429.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303 538C316.807 538 328 526.807 328 513C328 499.193 316.807 488 303 488C289.193 488 278 499.193 278 513C278 526.807 289.193 538 303 538ZM303 525.5C309.904 525.5 315.5 519.904 315.5 513C315.5 506.096 309.904 500.5 303 500.5C296.096 500.5 290.5 506.096 290.5 513C290.5 519.904 296.096 525.5 303 525.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294 607C307.807 607 319 595.807 319 582C319 568.193 307.807 557 294 557C280.193 557 269 568.193 269 582C269 595.807 280.193 607 294 607ZM294 594.5C300.904 594.5 306.5 588.904 306.5 582C306.5 575.096 300.904 569.5 294 569.5C287.096 569.5 281.5 575.096 281.5 582C281.5 588.904 287.096 594.5 294 594.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 686C311.807 686 323 674.807 323 661C323 647.193 311.807 636 298 636C284.193 636 273 647.193 273 661C273 674.807 284.193 686 298 686ZM298 673.5C304.904 673.5 310.5 667.904 310.5 661C310.5 654.096 304.904 648.5 298 648.5C291.096 648.5 285.5 654.096 285.5 661C285.5 667.904 291.096 673.5 298 673.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M310 756C323.807 756 335 744.807 335 731C335 717.193 323.807 706 310 706C296.193 706 285 717.193 285 731C285 744.807 296.193 756 310 756ZM310 743.5C316.904 743.5 322.5 737.904 322.5 731C322.5 724.096 316.904 718.5 310 718.5C303.096 718.5 297.5 724.096 297.5 731C297.5 737.904 303.096 743.5 310 743.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M378 510C391.807 510 403 498.807 403 485C403 471.193 391.807 460 378 460C364.193 460 353 471.193 353 485C353 498.807 364.193 510 378 510ZM378 497.5C384.904 497.5 390.5 491.904 390.5 485C390.5 478.096 384.904 472.5 378 472.5C371.096 472.5 365.5 478.096 365.5 485C365.5 491.904 371.096 497.5 378 497.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379 571C392.807 571 404 559.807 404 546C404 532.193 392.807 521 379 521C365.193 521 354 532.193 354 546C354 559.807 365.193 571 379 571ZM379 558.5C385.904 558.5 391.5 552.904 391.5 546C391.5 539.096 385.904 533.5 379 533.5C372.096 533.5 366.5 539.096 366.5 546C366.5 552.904 372.096 558.5 379 558.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M358 629C371.807 629 383 617.807 383 604C383 590.193 371.807 579 358 579C344.193 579 333 590.193 333 604C333 617.807 344.193 629 358 629ZM358 616.5C364.904 616.5 370.5 610.904 370.5 604C370.5 597.096 364.904 591.5 358 591.5C351.096 591.5 345.5 597.096 345.5 604C345.5 610.904 351.096 616.5 358 616.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360 690C373.807 690 385 678.807 385 665C385 651.193 373.807 640 360 640C346.193 640 335 651.193 335 665C335 678.807 346.193 690 360 690ZM360 677.5C366.904 677.5 372.5 671.904 372.5 665C372.5 658.096 366.904 652.5 360 652.5C353.096 652.5 347.5 658.096 347.5 665C347.5 671.904 353.096 677.5 360 677.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377 753C390.807 753 402 741.807 402 728C402 714.193 390.807 703 377 703C363.193 703 352 714.193 352 728C352 741.807 363.193 753 377 753ZM377 740.5C383.904 740.5 389.5 734.904 389.5 728C389.5 721.096 383.904 715.5 377 715.5C370.096 715.5 364.5 721.096 364.5 728C364.5 734.904 370.096 740.5 377 740.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366 814C379.807 814 391 802.807 391 789C391 775.193 379.807 764 366 764C352.193 764 341 775.193 341 789C341 802.807 352.193 814 366 814ZM366 801.5C372.904 801.5 378.5 795.904 378.5 789C378.5 782.096 372.904 776.5 366 776.5C359.096 776.5 353.5 782.096 353.5 789C353.5 795.904 359.096 801.5 366 801.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1066 584C1079.81 584 1091 572.807 1091 559C1091 545.193 1079.81 534 1066 534C1052.19 534 1041 545.193 1041 559C1041 572.807 1052.19 584 1066 584ZM1066 571.5C1072.9 571.5 1078.5 565.904 1078.5 559C1078.5 552.096 1072.9 546.5 1066 546.5C1059.1 546.5 1053.5 552.096 1053.5 559C1053.5 565.904 1059.1 571.5 1066 571.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474 903C487.807 903 499 891.807 499 878C499 864.193 487.807 853 474 853C460.193 853 449 864.193 449 878C449 891.807 460.193 903 474 903ZM474 890.5C480.904 890.5 486.5 884.904 486.5 878C486.5 871.096 480.904 865.5 474 865.5C467.096 865.5 461.5 871.096 461.5 878C461.5 884.904 467.096 890.5 474 890.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M868 982C881.807 982 893 970.807 893 957C893 943.193 881.807 932 868 932C854.193 932 843 943.193 843 957C843 970.807 854.193 982 868 982ZM868 969.5C874.904 969.5 880.5 963.904 880.5 957C880.5 950.096 874.904 944.5 868 944.5C861.096 944.5 855.5 950.096 855.5 957C855.5 963.904 861.096 969.5 868 969.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1033 285C1046.81 285 1058 273.807 1058 260C1058 246.193 1046.81 235 1033 235C1019.19 235 1008 246.193 1008 260C1008 273.807 1019.19 285 1033 285ZM1033 272.5C1039.9 272.5 1045.5 266.904 1045.5 260C1045.5 253.096 1039.9 247.5 1033 247.5C1026.1 247.5 1020.5 253.096 1020.5 260C1020.5 266.904 1026.1 272.5 1033 272.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M664 593C677.807 593 689 581.807 689 568C689 554.193 677.807 543 664 543C650.193 543 639 554.193 639 568C639 581.807 650.193 593 664 593ZM664 580.5C670.904 580.5 676.5 574.904 676.5 568C676.5 561.096 670.904 555.5 664 555.5C657.096 555.5 651.5 561.096 651.5 568C651.5 574.904 657.096 580.5 664 580.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M508 450C521.807 450 533 438.807 533 425C533 411.193 521.807 400 508 400C494.193 400 483 411.193 483 425C483 438.807 494.193 450 508 450ZM508 437.5C514.904 437.5 520.5 431.904 520.5 425C520.5 418.096 514.904 412.5 508 412.5C501.096 412.5 495.5 418.096 495.5 425C495.5 431.904 501.096 437.5 508 437.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1131 618C1144.81 618 1156 606.807 1156 593C1156 579.193 1144.81 568 1131 568C1117.19 568 1106 579.193 1106 593C1106 606.807 1117.19 618 1131 618ZM1131 605.5C1137.9 605.5 1143.5 599.904 1143.5 593C1143.5 586.096 1137.9 580.5 1131 580.5C1124.1 580.5 1118.5 586.096 1118.5 593C1118.5 599.904 1124.1 605.5 1131 605.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M541 939C554.807 939 566 927.807 566 914C566 900.193 554.807 889 541 889C527.193 889 516 900.193 516 914C516 927.807 527.193 939 541 939ZM541 926.5C547.904 926.5 553.5 920.904 553.5 914C553.5 907.096 547.904 901.5 541 901.5C534.096 901.5 528.5 907.096 528.5 914C528.5 920.904 534.096 926.5 541 926.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M652 870C665.807 870 677 858.807 677 845C677 831.193 665.807 820 652 820C638.193 820 627 831.193 627 845C627 858.807 638.193 870 652 870ZM652 857.5C658.904 857.5 664.5 851.904 664.5 845C664.5 838.096 658.904 832.5 652 832.5C645.096 832.5 639.5 838.096 639.5 845C639.5 851.904 645.096 857.5 652 857.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M759 890C772.807 890 784 878.807 784 865C784 851.193 772.807 840 759 840C745.193 840 734 851.193 734 865C734 878.807 745.193 890 759 890ZM759 877.5C765.904 877.5 771.5 871.904 771.5 865C771.5 858.096 765.904 852.5 759 852.5C752.096 852.5 746.5 858.096 746.5 865C746.5 871.904 752.096 877.5 759 877.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687 919C700.807 919 712 907.807 712 894C712 880.193 700.807 869 687 869C673.193 869 662 880.193 662 894C662 907.807 673.193 919 687 919ZM687 906.5C693.904 906.5 699.5 900.904 699.5 894C699.5 887.096 693.904 881.5 687 881.5C680.096 881.5 674.5 887.096 674.5 894C674.5 900.904 680.096 906.5 687 906.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M764 957C777.807 957 789 945.807 789 932C789 918.193 777.807 907 764 907C750.193 907 739 918.193 739 932C739 945.807 750.193 957 764 957ZM764 944.5C770.904 944.5 776.5 938.904 776.5 932C776.5 925.096 770.904 919.5 764 919.5C757.096 919.5 751.5 925.096 751.5 932C751.5 938.904 757.096 944.5 764 944.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M798 1010C811.807 1010 823 998.807 823 985C823 971.193 811.807 960 798 960C784.193 960 773 971.193 773 985C773 998.807 784.193 1010 798 1010ZM798 997.5C804.904 997.5 810.5 991.904 810.5 985C810.5 978.096 804.904 972.5 798 972.5C791.096 972.5 785.5 978.096 785.5 985C785.5 991.904 791.096 997.5 798 997.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1093 317C1106.81 317 1118 305.807 1118 292C1118 278.193 1106.81 267 1093 267C1079.19 267 1068 278.193 1068 292C1068 305.807 1079.19 317 1093 317ZM1093 304.5C1099.9 304.5 1105.5 298.904 1105.5 292C1105.5 285.096 1099.9 279.5 1093 279.5C1086.1 279.5 1080.5 285.096 1080.5 292C1080.5 298.904 1086.1 304.5 1093 304.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1030 345C1043.81 345 1055 333.807 1055 320C1055 306.193 1043.81 295 1030 295C1016.19 295 1005 306.193 1005 320C1005 333.807 1016.19 345 1030 345ZM1030 332.5C1036.9 332.5 1042.5 326.904 1042.5 320C1042.5 313.096 1036.9 307.5 1030 307.5C1023.1 307.5 1017.5 313.096 1017.5 320C1017.5 326.904 1023.1 332.5 1030 332.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M971 358C984.807 358 996 346.807 996 333C996 319.193 984.807 308 971 308C957.193 308 946 319.193 946 333C946 346.807 957.193 358 971 358ZM971 345.5C977.904 345.5 983.5 339.904 983.5 333C983.5 326.096 977.904 320.5 971 320.5C964.096 320.5 958.5 326.096 958.5 333C958.5 339.904 964.096 345.5 971 345.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1017 406C1030.81 406 1042 394.807 1042 381C1042 367.193 1030.81 356 1017 356C1003.19 356 992 367.193 992 381C992 394.807 1003.19 406 1017 406ZM1017 393.5C1023.9 393.5 1029.5 387.904 1029.5 381C1029.5 374.096 1023.9 368.5 1017 368.5C1010.1 368.5 1004.5 374.096 1004.5 381C1004.5 387.904 1010.1 393.5 1017 393.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M768 596C781.807 596 793 584.807 793 571C793 557.193 781.807 546 768 546C754.193 546 743 557.193 743 571C743 584.807 754.193 596 768 596ZM768 583.5C774.904 583.5 780.5 577.904 780.5 571C780.5 564.096 774.904 558.5 768 558.5C761.096 558.5 755.5 564.096 755.5 571C755.5 577.904 761.096 583.5 768 583.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M805 643C818.807 643 830 631.807 830 618C830 604.193 818.807 593 805 593C791.193 593 780 604.193 780 618C780 631.807 791.193 643 805 643ZM805 630.5C811.904 630.5 817.5 624.904 817.5 618C817.5 611.096 811.904 605.5 805 605.5C798.096 605.5 792.5 611.096 792.5 618C792.5 624.904 798.096 630.5 805 630.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186 656C1199.81 656 1211 644.807 1211 631C1211 617.193 1199.81 606 1186 606C1172.19 606 1161 617.193 1161 631C1161 644.807 1172.19 656 1186 656ZM1186 643.5C1192.9 643.5 1198.5 637.904 1198.5 631C1198.5 624.096 1192.9 618.5 1186 618.5C1179.1 618.5 1173.5 624.096 1173.5 631C1173.5 637.904 1179.1 643.5 1186 643.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886 636C899.807 636 911 624.807 911 611C911 597.193 899.807 586 886 586C872.193 586 861 597.193 861 611C861 624.807 872.193 636 886 636ZM886 623.5C892.904 623.5 898.5 617.904 898.5 611C898.5 604.096 892.904 598.5 886 598.5C879.096 598.5 873.5 604.096 873.5 611C873.5 617.904 879.096 623.5 886 623.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1234 751C1247.81 751 1259 739.807 1259 726C1259 712.193 1247.81 701 1234 701C1220.19 701 1209 712.193 1209 726C1209 739.807 1220.19 751 1234 751ZM1234 738.5C1240.9 738.5 1246.5 732.904 1246.5 726C1246.5 719.096 1240.9 713.5 1234 713.5C1227.1 713.5 1221.5 719.096 1221.5 726C1221.5 732.904 1227.1 738.5 1234 738.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1254 677C1267.81 677 1279 665.807 1279 652C1279 638.193 1267.81 627 1254 627C1240.19 627 1229 638.193 1229 652C1229 665.807 1240.19 677 1254 677ZM1254 664.5C1260.9 664.5 1266.5 658.904 1266.5 652C1266.5 645.096 1260.9 639.5 1254 639.5C1247.1 639.5 1241.5 645.096 1241.5 652C1241.5 658.904 1247.1 664.5 1254 664.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1184 586C1197.81 586 1209 574.807 1209 561C1209 547.193 1197.81 536 1184 536C1170.19 536 1159 547.193 1159 561C1159 574.807 1170.19 586 1184 586ZM1184 573.5C1190.9 573.5 1196.5 567.904 1196.5 561C1196.5 554.096 1190.9 548.5 1184 548.5C1177.1 548.5 1171.5 554.096 1171.5 561C1171.5 567.904 1177.1 573.5 1184 573.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1181 520C1194.81 520 1206 508.807 1206 495C1206 481.193 1194.81 470 1181 470C1167.19 470 1156 481.193 1156 495C1156 508.807 1167.19 520 1181 520ZM1181 507.5C1187.9 507.5 1193.5 501.904 1193.5 495C1193.5 488.096 1187.9 482.5 1181 482.5C1174.1 482.5 1168.5 488.096 1168.5 495C1168.5 501.904 1174.1 507.5 1181 507.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1195 458C1208.81 458 1220 446.807 1220 433C1220 419.193 1208.81 408 1195 408C1181.19 408 1170 419.193 1170 433C1170 446.807 1181.19 458 1195 458ZM1195 445.5C1201.9 445.5 1207.5 439.904 1207.5 433C1207.5 426.096 1201.9 420.5 1195 420.5C1188.1 420.5 1182.5 426.096 1182.5 433C1182.5 439.904 1188.1 445.5 1195 445.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1234 547C1247.81 547 1259 535.807 1259 522C1259 508.193 1247.81 497 1234 497C1220.19 497 1209 508.193 1209 522C1209 535.807 1220.19 547 1234 547ZM1234 534.5C1240.9 534.5 1246.5 528.904 1246.5 522C1246.5 515.096 1240.9 509.5 1234 509.5C1227.1 509.5 1221.5 515.096 1221.5 522C1221.5 528.904 1227.1 534.5 1234 534.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238 612C1251.81 612 1263 600.807 1263 587C1263 573.193 1251.81 562 1238 562C1224.19 562 1213 573.193 1213 587C1213 600.807 1224.19 612 1238 612ZM1238 599.5C1244.9 599.5 1250.5 593.904 1250.5 587C1250.5 580.096 1244.9 574.5 1238 574.5C1231.1 574.5 1225.5 580.096 1225.5 587C1225.5 593.904 1231.1 599.5 1238 599.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1256 491C1269.81 491 1281 479.807 1281 466C1281 452.193 1269.81 441 1256 441C1242.19 441 1231 452.193 1231 466C1231 479.807 1242.19 491 1256 491ZM1256 478.5C1262.9 478.5 1268.5 472.904 1268.5 466C1268.5 459.096 1262.9 453.5 1256 453.5C1249.1 453.5 1243.5 459.096 1243.5 466C1243.5 472.904 1249.1 478.5 1256 478.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1304 455C1317.81 455 1329 443.807 1329 430C1329 416.193 1317.81 405 1304 405C1290.19 405 1279 416.193 1279 430C1279 443.807 1290.19 455 1304 455ZM1304 442.5C1310.9 442.5 1316.5 436.904 1316.5 430C1316.5 423.096 1310.9 417.5 1304 417.5C1297.1 417.5 1291.5 423.096 1291.5 430C1291.5 436.904 1297.1 442.5 1304 442.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1273 317C1286.81 317 1298 305.807 1298 292C1298 278.193 1286.81 267 1273 267C1259.19 267 1248 278.193 1248 292C1248 305.807 1259.19 317 1273 317ZM1273 304.5C1279.9 304.5 1285.5 298.904 1285.5 292C1285.5 285.096 1279.9 279.5 1273 279.5C1266.1 279.5 1260.5 285.096 1260.5 292C1260.5 298.904 1266.1 304.5 1273 304.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1247 252C1260.81 252 1272 240.807 1272 227C1272 213.193 1260.81 202 1247 202C1233.19 202 1222 213.193 1222 227C1222 240.807 1233.19 252 1247 252ZM1247 239.5C1253.9 239.5 1259.5 233.904 1259.5 227C1259.5 220.096 1253.9 214.5 1247 214.5C1240.1 214.5 1234.5 220.096 1234.5 227C1234.5 233.904 1240.1 239.5 1247 239.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1235 191C1248.81 191 1260 179.807 1260 166C1260 152.193 1248.81 141 1235 141C1221.19 141 1210 152.193 1210 166C1210 179.807 1221.19 191 1235 191ZM1235 178.5C1241.9 178.5 1247.5 172.904 1247.5 166C1247.5 159.096 1241.9 153.5 1235 153.5C1228.1 153.5 1222.5 159.096 1222.5 166C1222.5 172.904 1228.1 178.5 1235 178.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1292 385C1305.81 385 1317 373.807 1317 360C1317 346.193 1305.81 335 1292 335C1278.19 335 1267 346.193 1267 360C1267 373.807 1278.19 385 1292 385ZM1292 372.5C1298.9 372.5 1304.5 366.904 1304.5 360C1304.5 353.096 1298.9 347.5 1292 347.5C1285.1 347.5 1279.5 353.096 1279.5 360C1279.5 366.904 1285.1 372.5 1292 372.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1292 584C1305.81 584 1317 572.807 1317 559C1317 545.193 1305.81 534 1292 534C1278.19 534 1267 545.193 1267 559C1267 572.807 1278.19 584 1292 584ZM1292 571.5C1298.9 571.5 1304.5 565.904 1304.5 559C1304.5 552.096 1298.9 546.5 1292 546.5C1285.1 546.5 1279.5 552.096 1279.5 559C1279.5 565.904 1285.1 571.5 1292 571.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311 525C1324.81 525 1336 513.807 1336 500C1336 486.193 1324.81 475 1311 475C1297.19 475 1286 486.193 1286 500C1286 513.807 1297.19 525 1311 525ZM1311 512.5C1317.9 512.5 1323.5 506.904 1323.5 500C1323.5 493.096 1317.9 487.5 1311 487.5C1304.1 487.5 1298.5 493.096 1298.5 500C1298.5 506.904 1304.1 512.5 1311 512.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1187 233C1200.81 233 1212 221.807 1212 208C1212 194.193 1200.81 183 1187 183C1173.19 183 1162 194.193 1162 208C1162 221.807 1173.19 233 1187 233ZM1187 220.5C1193.9 220.5 1199.5 214.904 1199.5 208C1199.5 201.096 1193.9 195.5 1187 195.5C1180.1 195.5 1174.5 201.096 1174.5 208C1174.5 214.904 1180.1 220.5 1187 220.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1180 159C1193.81 159 1205 147.807 1205 134C1205 120.193 1193.81 109 1180 109C1166.19 109 1155 120.193 1155 134C1155 147.807 1166.19 159 1180 159ZM1180 146.5C1186.9 146.5 1192.5 140.904 1192.5 134C1192.5 127.096 1186.9 121.5 1180 121.5C1173.1 121.5 1167.5 127.096 1167.5 134C1167.5 140.904 1173.1 146.5 1180 146.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1311 645C1324.81 645 1336 633.807 1336 620C1336 606.193 1324.81 595 1311 595C1297.19 595 1286 606.193 1286 620C1286 633.807 1297.19 645 1311 645ZM1311 632.5C1317.9 632.5 1323.5 626.904 1323.5 620C1323.5 613.096 1317.9 607.5 1311 607.5C1304.1 607.5 1298.5 613.096 1298.5 620C1298.5 626.904 1304.1 632.5 1311 632.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1245 426C1258.81 426 1270 414.807 1270 401C1270 387.193 1258.81 376 1245 376C1231.19 376 1220 387.193 1220 401C1220 414.807 1231.19 426 1245 426ZM1245 413.5C1251.9 413.5 1257.5 407.904 1257.5 401C1257.5 394.096 1251.9 388.5 1245 388.5C1238.1 388.5 1232.5 394.096 1232.5 401C1232.5 407.904 1238.1 413.5 1245 413.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1219 367C1232.81 367 1244 355.807 1244 342C1244 328.193 1232.81 317 1219 317C1205.19 317 1194 328.193 1194 342C1194 355.807 1205.19 367 1219 367ZM1219 354.5C1225.9 354.5 1231.5 348.904 1231.5 342C1231.5 335.096 1225.9 329.5 1219 329.5C1212.1 329.5 1206.5 335.096 1206.5 342C1206.5 348.904 1212.1 354.5 1219 354.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M718 648C731.807 648 743 636.807 743 623C743 609.193 731.807 598 718 598C704.193 598 693 609.193 693 623C693 636.807 704.193 648 718 648ZM718 635.5C724.904 635.5 730.5 629.904 730.5 623C730.5 616.096 724.904 610.5 718 610.5C711.096 610.5 705.5 616.096 705.5 623C705.5 629.904 711.096 635.5 718 635.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1066 720C1079.81 720 1091 708.807 1091 695C1091 681.193 1079.81 670 1066 670C1052.19 670 1041 681.193 1041 695C1041 708.807 1052.19 720 1066 720ZM1066 707.5C1072.9 707.5 1078.5 701.904 1078.5 695C1078.5 688.096 1072.9 682.5 1066 682.5C1059.1 682.5 1053.5 688.096 1053.5 695C1053.5 701.904 1059.1 707.5 1066 707.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M593 615C606.807 615 618 603.807 618 590C618 576.193 606.807 565 593 565C579.193 565 568 576.193 568 590C568 603.807 579.193 615 593 615ZM593 602.5C599.904 602.5 605.5 596.904 605.5 590C605.5 583.096 599.904 577.5 593 577.5C586.096 577.5 580.5 583.096 580.5 590C580.5 596.904 586.096 602.5 593 602.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433 481C446.807 481 458 469.807 458 456C458 442.193 446.807 431 433 431C419.193 431 408 442.193 408 456C408 469.807 419.193 481 433 481ZM433 468.5C439.904 468.5 445.5 462.904 445.5 456C445.5 449.096 439.904 443.5 433 443.5C426.096 443.5 420.5 449.096 420.5 456C420.5 462.904 426.096 468.5 433 468.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1069 657C1082.81 657 1094 645.807 1094 632C1094 618.193 1082.81 607 1069 607C1055.19 607 1044 618.193 1044 632C1044 645.807 1055.19 657 1069 657ZM1069 644.5C1075.9 644.5 1081.5 638.904 1081.5 632C1081.5 625.096 1075.9 619.5 1069 619.5C1062.1 619.5 1056.5 625.096 1056.5 632C1056.5 638.904 1062.1 644.5 1069 644.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1007 609C1020.81 609 1032 597.807 1032 584C1032 570.193 1020.81 559 1007 559C993.193 559 982 570.193 982 584C982 597.807 993.193 609 1007 609ZM1007 596.5C1013.9 596.5 1019.5 590.904 1019.5 584C1019.5 577.096 1013.9 571.5 1007 571.5C1000.1 571.5 994.5 577.096 994.5 584C994.5 590.904 1000.1 596.5 1007 596.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647 654C660.807 654 672 642.807 672 629C672 615.193 660.807 604 647 604C633.193 604 622 615.193 622 629C622 642.807 633.193 654 647 654ZM647 641.5C653.904 641.5 659.5 635.904 659.5 629C659.5 622.096 653.904 616.5 647 616.5C640.096 616.5 634.5 622.096 634.5 629C634.5 635.904 640.096 641.5 647 641.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M493 517C506.807 517 518 505.807 518 492C518 478.193 506.807 467 493 467C479.193 467 468 478.193 468 492C468 505.807 479.193 517 493 517ZM493 504.5C499.904 504.5 505.5 498.904 505.5 492C505.5 485.096 499.904 479.5 493 479.5C486.096 479.5 480.5 485.096 480.5 492C480.5 498.904 486.096 504.5 493 504.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005 686C1018.81 686 1030 674.807 1030 661C1030 647.193 1018.81 636 1005 636C991.193 636 980 647.193 980 661C980 674.807 991.193 686 1005 686ZM1005 673.5C1011.9 673.5 1017.5 667.904 1017.5 661C1017.5 654.096 1011.9 648.5 1005 648.5C998.096 648.5 992.5 654.096 992.5 661C992.5 667.904 998.096 673.5 1005 673.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M762 693C775.807 693 787 681.807 787 668C787 654.193 775.807 643 762 643C748.193 643 737 654.193 737 668C737 681.807 748.193 693 762 693ZM762 680.5C768.904 680.5 774.5 674.904 774.5 668C774.5 661.096 768.904 655.5 762 655.5C755.096 655.5 749.5 661.096 749.5 668C749.5 674.904 755.096 680.5 762 680.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1126 753C1139.81 753 1151 741.807 1151 728C1151 714.193 1139.81 703 1126 703C1112.19 703 1101 714.193 1101 728C1101 741.807 1112.19 753 1126 753ZM1126 740.5C1132.9 740.5 1138.5 734.904 1138.5 728C1138.5 721.096 1132.9 715.5 1126 715.5C1119.1 715.5 1113.5 721.096 1113.5 728C1113.5 734.904 1119.1 740.5 1126 740.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M672 718C685.807 718 697 706.807 697 693C697 679.193 685.807 668 672 668C658.193 668 647 679.193 647 693C647 706.807 658.193 718 672 718ZM672 705.5C678.904 705.5 684.5 699.904 684.5 693C684.5 686.096 678.904 680.5 672 680.5C665.096 680.5 659.5 686.096 659.5 693C659.5 699.904 665.096 705.5 672 705.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551 568C564.807 568 576 556.807 576 543C576 529.193 564.807 518 551 518C537.193 518 526 529.193 526 543C526 556.807 537.193 568 551 568ZM551 555.5C557.904 555.5 563.5 549.904 563.5 543C563.5 536.096 557.904 530.5 551 530.5C544.096 530.5 538.5 536.096 538.5 543C538.5 549.904 544.096 555.5 551 555.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M491 589C504.807 589 516 577.807 516 564C516 550.193 504.807 539 491 539C477.193 539 466 550.193 466 564C466 577.807 477.193 589 491 589ZM491 576.5C497.904 576.5 503.5 570.904 503.5 564C503.5 557.096 497.904 551.5 491 551.5C484.096 551.5 478.5 557.096 478.5 564C478.5 570.904 484.096 576.5 491 576.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538 643C551.807 643 563 631.807 563 618C563 604.193 551.807 593 538 593C524.193 593 513 604.193 513 618C513 631.807 524.193 643 538 643ZM538 630.5C544.904 630.5 550.5 624.904 550.5 618C550.5 611.096 544.904 605.5 538 605.5C531.096 605.5 525.5 611.096 525.5 618C525.5 624.904 531.096 630.5 538 630.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538 728C551.807 728 563 716.807 563 703C563 689.193 551.807 678 538 678C524.193 678 513 689.193 513 703C513 716.807 524.193 728 538 728ZM538 715.5C544.904 715.5 550.5 709.904 550.5 703C550.5 696.096 544.904 690.5 538 690.5C531.096 690.5 525.5 696.096 525.5 703C525.5 709.904 531.096 715.5 538 715.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1037 776C1050.81 776 1062 764.807 1062 751C1062 737.193 1050.81 726 1037 726C1023.19 726 1012 737.193 1012 751C1012 764.807 1023.19 776 1037 776ZM1037 763.5C1043.9 763.5 1049.5 757.904 1049.5 751C1049.5 744.096 1043.9 738.5 1037 738.5C1030.1 738.5 1024.5 744.096 1024.5 751C1024.5 757.904 1030.1 763.5 1037 763.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M993 820C1006.81 820 1018 808.807 1018 795C1018 781.193 1006.81 770 993 770C979.193 770 968 781.193 968 795C968 808.807 979.193 820 993 820ZM993 807.5C999.904 807.5 1005.5 801.904 1005.5 795C1005.5 788.096 999.904 782.5 993 782.5C986.096 782.5 980.5 788.096 980.5 795C980.5 801.904 986.096 807.5 993 807.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1041 858C1054.81 858 1066 846.807 1066 833C1066 819.193 1054.81 808 1041 808C1027.19 808 1016 819.193 1016 833C1016 846.807 1027.19 858 1041 858ZM1041 845.5C1047.9 845.5 1053.5 839.904 1053.5 833C1053.5 826.096 1047.9 820.5 1041 820.5C1034.1 820.5 1028.5 826.096 1028.5 833C1028.5 839.904 1034.1 845.5 1041 845.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016 919C1029.81 919 1041 907.807 1041 894C1041 880.193 1029.81 869 1016 869C1002.19 869 991 880.193 991 894C991 907.807 1002.19 919 1016 919ZM1016 906.5C1022.9 906.5 1028.5 900.904 1028.5 894C1028.5 887.096 1022.9 881.5 1016 881.5C1009.1 881.5 1003.5 887.096 1003.5 894C1003.5 900.904 1009.1 906.5 1016 906.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1144 848C1157.81 848 1169 836.807 1169 823C1169 809.193 1157.81 798 1144 798C1130.19 798 1119 809.193 1119 823C1119 836.807 1130.19 848 1144 848ZM1144 835.5C1150.9 835.5 1156.5 829.904 1156.5 823C1156.5 816.096 1150.9 810.5 1144 810.5C1137.1 810.5 1131.5 816.096 1131.5 823C1131.5 829.904 1137.1 835.5 1144 835.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151 924C1164.81 924 1176 912.807 1176 899C1176 885.193 1164.81 874 1151 874C1137.19 874 1126 885.193 1126 899C1126 912.807 1137.19 924 1151 924ZM1151 911.5C1157.9 911.5 1163.5 905.904 1163.5 899C1163.5 892.096 1157.9 886.5 1151 886.5C1144.1 886.5 1138.5 892.096 1138.5 899C1138.5 905.904 1144.1 911.5 1151 911.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1205 870C1218.81 870 1230 858.807 1230 845C1230 831.193 1218.81 820 1205 820C1191.19 820 1180 831.193 1180 845C1180 858.807 1191.19 870 1205 870ZM1205 857.5C1211.9 857.5 1217.5 851.904 1217.5 845C1217.5 838.096 1211.9 832.5 1205 832.5C1198.1 832.5 1192.5 838.096 1192.5 845C1192.5 851.904 1198.1 857.5 1205 857.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1259 808C1272.81 808 1284 796.807 1284 783C1284 769.193 1272.81 758 1259 758C1245.19 758 1234 769.193 1234 783C1234 796.807 1245.19 808 1259 808ZM1259 795.5C1265.9 795.5 1271.5 789.904 1271.5 783C1271.5 776.096 1265.9 770.5 1259 770.5C1252.1 770.5 1246.5 776.096 1246.5 783C1246.5 789.904 1252.1 795.5 1259 795.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1297 726C1310.81 726 1322 714.807 1322 701C1322 687.193 1310.81 676 1297 676C1283.19 676 1272 687.193 1272 701C1272 714.807 1283.19 726 1297 726ZM1297 713.5C1303.9 713.5 1309.5 707.904 1309.5 701C1309.5 694.096 1303.9 688.5 1297 688.5C1290.1 688.5 1284.5 694.096 1284.5 701C1284.5 707.904 1290.1 713.5 1297 713.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1089 903C1102.81 903 1114 891.807 1114 878C1114 864.193 1102.81 853 1089 853C1075.19 853 1064 864.193 1064 878C1064 891.807 1075.19 903 1089 903ZM1089 890.5C1095.9 890.5 1101.5 884.904 1101.5 878C1101.5 871.096 1095.9 865.5 1089 865.5C1082.1 865.5 1076.5 871.096 1076.5 878C1076.5 884.904 1082.1 890.5 1089 890.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1005 988C1018.81 988 1030 976.807 1030 963C1030 949.193 1018.81 938 1005 938C991.193 938 980 949.193 980 963C980 976.807 991.193 988 1005 988ZM1005 975.5C1011.9 975.5 1017.5 969.904 1017.5 963C1017.5 956.096 1011.9 950.5 1005 950.5C998.096 950.5 992.5 956.096 992.5 963C992.5 969.904 998.096 975.5 1005 975.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070 966C1083.81 966 1095 954.807 1095 941C1095 927.193 1083.81 916 1070 916C1056.19 916 1045 927.193 1045 941C1045 954.807 1056.19 966 1070 966ZM1070 953.5C1076.9 953.5 1082.5 947.904 1082.5 941C1082.5 934.096 1076.9 928.5 1070 928.5C1063.1 928.5 1057.5 934.096 1057.5 941C1057.5 947.904 1063.1 953.5 1070 953.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954 641C967.807 641 979 629.807 979 616C979 602.193 967.807 591 954 591C940.193 591 929 602.193 929 616C929 629.807 940.193 641 954 641ZM954 628.5C960.904 628.5 966.5 622.904 966.5 616C966.5 609.096 960.904 603.5 954 603.5C947.096 603.5 941.5 609.096 941.5 616C941.5 622.904 947.096 628.5 954 628.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M615 757C628.807 757 640 745.807 640 732C640 718.193 628.807 707 615 707C601.193 707 590 718.193 590 732C590 745.807 601.193 757 615 757ZM615 744.5C621.904 744.5 627.5 738.904 627.5 732C627.5 725.096 621.904 719.5 615 719.5C608.096 719.5 602.5 725.096 602.5 732C602.5 738.904 608.096 744.5 615 744.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M677 786C690.807 786 702 774.807 702 761C702 747.193 690.807 736 677 736C663.193 736 652 747.193 652 761C652 774.807 663.193 786 677 786ZM677 773.5C683.904 773.5 689.5 767.904 689.5 761C689.5 754.096 683.904 748.5 677 748.5C670.096 748.5 664.5 754.096 664.5 761C664.5 767.904 670.096 773.5 677 773.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M711 837C724.807 837 736 825.807 736 812C736 798.193 724.807 787 711 787C697.193 787 686 798.193 686 812C686 825.807 697.193 837 711 837ZM711 824.5C717.904 824.5 723.5 818.904 723.5 812C723.5 805.096 717.904 799.5 711 799.5C704.096 799.5 698.5 805.096 698.5 812C698.5 818.904 704.096 824.5 711 824.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M607 826C620.807 826 632 814.807 632 801C632 787.193 620.807 776 607 776C593.193 776 582 787.193 582 801C582 814.807 593.193 826 607 826ZM607 813.5C613.904 813.5 619.5 807.904 619.5 801C619.5 794.096 613.904 788.5 607 788.5C600.096 788.5 594.5 794.096 594.5 801C594.5 807.904 600.096 813.5 607 813.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M853 803C866.807 803 878 791.807 878 778C878 764.193 866.807 753 853 753C839.193 753 828 764.193 828 778C828 791.807 839.193 803 853 803ZM853 790.5C859.904 790.5 865.5 784.904 865.5 778C865.5 771.096 859.904 765.5 853 765.5C846.096 765.5 840.5 771.096 840.5 778C840.5 784.904 846.096 790.5 853 790.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M780 812C793.807 812 805 800.807 805 787C805 773.193 793.807 762 780 762C766.193 762 755 773.193 755 787C755 800.807 766.193 812 780 812ZM780 799.5C786.904 799.5 792.5 793.904 792.5 787C792.5 780.096 786.904 774.5 780 774.5C773.096 774.5 767.5 780.096 767.5 787C767.5 793.904 773.096 799.5 780 799.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M811 743C824.807 743 836 731.807 836 718C836 704.193 824.807 693 811 693C797.193 693 786 704.193 786 718C786 731.807 797.193 743 811 743ZM811 730.5C817.904 730.5 823.5 724.904 823.5 718C823.5 711.096 817.904 705.5 811 705.5C804.096 705.5 798.5 711.096 798.5 718C798.5 724.904 804.096 730.5 811 730.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1186 803C1199.81 803 1211 791.807 1211 778C1211 764.193 1199.81 753 1186 753C1172.19 753 1161 764.193 1161 778C1161 791.807 1172.19 803 1186 803ZM1186 790.5C1192.9 790.5 1198.5 784.904 1198.5 778C1198.5 771.096 1192.9 765.5 1186 765.5C1179.1 765.5 1173.5 771.096 1173.5 778C1173.5 784.904 1179.1 790.5 1186 790.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886 748C899.807 748 911 736.807 911 723C911 709.193 899.807 698 886 698C872.193 698 861 709.193 861 723C861 736.807 872.193 748 886 748ZM886 735.5C892.904 735.5 898.5 729.904 898.5 723C898.5 716.096 892.904 710.5 886 710.5C879.096 710.5 873.5 716.096 873.5 723C873.5 729.904 879.096 735.5 886 735.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1188 715C1201.81 715 1213 703.807 1213 690C1213 676.193 1201.81 665 1188 665C1174.19 665 1163 676.193 1163 690C1163 703.807 1174.19 715 1188 715ZM1188 702.5C1194.9 702.5 1200.5 696.904 1200.5 690C1200.5 683.096 1194.9 677.5 1188 677.5C1181.1 677.5 1175.5 683.096 1175.5 690C1175.5 696.904 1181.1 702.5 1188 702.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M930 798C943.807 798 955 786.807 955 773C955 759.193 943.807 748 930 748C916.193 748 905 759.193 905 773C905 786.807 916.193 798 930 798ZM930 785.5C936.904 785.5 942.5 779.904 942.5 773C942.5 766.096 936.904 760.5 930 760.5C923.096 760.5 917.5 766.096 917.5 773C917.5 779.904 923.096 785.5 930 785.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M737 752C750.807 752 762 740.807 762 727C762 713.193 750.807 702 737 702C723.193 702 712 713.193 712 727C712 740.807 723.193 752 737 752ZM737 739.5C743.904 739.5 749.5 733.904 749.5 727C749.5 720.096 743.904 714.5 737 714.5C730.096 714.5 724.5 720.096 724.5 727C724.5 733.904 730.096 739.5 737 739.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1099 813C1112.81 813 1124 801.807 1124 788C1124 774.193 1112.81 763 1099 763C1085.19 763 1074 774.193 1074 788C1074 801.807 1085.19 813 1099 813ZM1099 800.5C1105.9 800.5 1111.5 794.904 1111.5 788C1111.5 781.096 1105.9 775.5 1099 775.5C1092.1 775.5 1086.5 781.096 1086.5 788C1086.5 794.904 1092.1 800.5 1099 800.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M591 693C604.807 693 616 681.807 616 668C616 654.193 604.807 643 591 643C577.193 643 566 654.193 566 668C566 681.807 577.193 693 591 693ZM591 680.5C597.904 680.5 603.5 674.904 603.5 668C603.5 661.096 597.904 655.5 591 655.5C584.096 655.5 578.5 661.096 578.5 668C578.5 674.904 584.096 680.5 591 680.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M438 541C451.807 541 463 529.807 463 516C463 502.193 451.807 491 438 491C424.193 491 413 502.193 413 516C413 529.807 424.193 541 438 541ZM438 528.5C444.904 528.5 450.5 522.904 450.5 516C450.5 509.096 444.904 503.5 438 503.5C431.096 503.5 425.5 509.096 425.5 516C425.5 522.904 431.096 528.5 438 528.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M974 743C987.807 743 999 731.807 999 718C999 704.193 987.807 693 974 693C960.193 693 949 704.193 949 718C949 731.807 960.193 743 974 743ZM974 730.5C980.904 730.5 986.5 724.904 986.5 718C986.5 711.096 980.904 705.5 974 705.5C967.096 705.5 961.5 711.096 961.5 718C961.5 724.904 967.096 730.5 974 730.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843 693C856.807 693 868 681.807 868 668C868 654.193 856.807 643 843 643C829.193 643 818 654.193 818 668C818 681.807 829.193 693 843 693ZM843 680.5C849.904 680.5 855.5 674.904 855.5 668C855.5 661.096 849.904 655.5 843 655.5C836.096 655.5 830.5 661.096 830.5 668C830.5 674.904 836.096 680.5 843 680.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921 695C934.807 695 946 683.807 946 670C946 656.193 934.807 645 921 645C907.193 645 896 656.193 896 670C896 683.807 907.193 695 921 695ZM921 682.5C927.904 682.5 933.5 676.904 933.5 670C933.5 663.096 927.904 657.5 921 657.5C914.096 657.5 908.5 663.096 908.5 670C908.5 676.904 914.096 682.5 921 682.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1131 686C1144.81 686 1156 674.807 1156 661C1156 647.193 1144.81 636 1131 636C1117.19 636 1106 647.193 1106 661C1106 674.807 1117.19 686 1131 686ZM1131 673.5C1137.9 673.5 1143.5 667.904 1143.5 661C1143.5 654.096 1137.9 648.5 1131 648.5C1124.1 648.5 1118.5 654.096 1118.5 661C1118.5 667.904 1124.1 673.5 1131 673.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M843 585C856.807 585 868 573.807 868 560C868 546.193 856.807 535 843 535C829.193 535 818 546.193 818 560C818 573.807 829.193 585 843 585ZM843 572.5C849.904 572.5 855.5 566.904 855.5 560C855.5 553.096 849.904 547.5 843 547.5C836.096 547.5 830.5 553.096 830.5 560C830.5 566.904 836.096 572.5 843 572.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M931 578C944.807 578 956 566.807 956 553C956 539.193 944.807 528 931 528C917.193 528 906 539.193 906 553C906 566.807 917.193 578 931 578ZM931 565.5C937.904 565.5 943.5 559.904 943.5 553C943.5 546.096 937.904 540.5 931 540.5C924.096 540.5 918.5 546.096 918.5 553C918.5 559.904 924.096 565.5 931 565.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M624 475C637.807 475 649 463.807 649 450C649 436.193 637.807 425 624 425C610.193 425 599 436.193 599 450C599 463.807 610.193 475 624 475ZM624 462.5C630.904 462.5 636.5 456.904 636.5 450C636.5 443.096 630.904 437.5 624 437.5C617.096 437.5 611.5 443.096 611.5 450C611.5 456.904 617.096 462.5 624 462.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449 347C462.807 347 474 335.807 474 322C474 308.193 462.807 297 449 297C435.193 297 424 308.193 424 322C424 335.807 435.193 347 449 347ZM449 334.5C455.904 334.5 461.5 328.904 461.5 322C461.5 315.096 455.904 309.5 449 309.5C442.096 309.5 436.5 315.096 436.5 322C436.5 328.904 442.096 334.5 449 334.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M549 263C562.807 263 574 251.807 574 238C574 224.193 562.807 213 549 213C535.193 213 524 224.193 524 238C524 251.807 535.193 263 549 263ZM549 250.5C555.904 250.5 561.5 244.904 561.5 238C561.5 231.096 555.904 225.5 549 225.5C542.096 225.5 536.5 231.096 536.5 238C536.5 244.904 542.096 250.5 549 250.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514 322C527.807 322 539 310.807 539 297C539 283.193 527.807 272 514 272C500.193 272 489 283.193 489 297C489 310.807 500.193 322 514 322ZM514 309.5C520.904 309.5 526.5 303.904 526.5 297C526.5 290.096 520.904 284.5 514 284.5C507.096 284.5 501.5 290.096 501.5 297C501.5 303.904 507.096 309.5 514 309.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479 277C492.807 277 504 265.807 504 252C504 238.193 492.807 227 479 227C465.193 227 454 238.193 454 252C454 265.807 465.193 277 479 277ZM479 264.5C485.904 264.5 491.5 258.904 491.5 252C491.5 245.096 485.904 239.5 479 239.5C472.096 239.5 466.5 245.096 466.5 252C466.5 258.904 472.096 264.5 479 264.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M507 222C520.807 222 532 210.807 532 197C532 183.193 520.807 172 507 172C493.193 172 482 183.193 482 197C482 210.807 493.193 222 507 222ZM507 209.5C513.904 209.5 519.5 203.904 519.5 197C519.5 190.096 513.904 184.5 507 184.5C500.096 184.5 494.5 190.096 494.5 197C494.5 203.904 500.096 209.5 507 209.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546 141C559.807 141 571 129.807 571 116C571 102.193 559.807 91 546 91C532.193 91 521 102.193 521 116C521 129.807 532.193 141 546 141ZM546 128.5C552.904 128.5 558.5 122.904 558.5 116C558.5 109.096 552.904 103.5 546 103.5C539.096 103.5 533.5 109.096 533.5 116C533.5 122.904 539.096 128.5 546 128.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583 71C596.807 71 608 59.8071 608 46C608 32.1929 596.807 21 583 21C569.193 21 558 32.1929 558 46C558 59.8071 569.193 71 583 71ZM583 58.5C589.904 58.5 595.5 52.9036 595.5 46C595.5 39.0964 589.904 33.5 583 33.5C576.096 33.5 570.5 39.0964 570.5 46C570.5 52.9036 576.096 58.5 583 58.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M404 304C417.807 304 429 292.807 429 279C429 265.193 417.807 254 404 254C390.193 254 379 265.193 379 279C379 292.807 390.193 304 404 304ZM404 291.5C410.904 291.5 416.5 285.904 416.5 279C416.5 272.096 410.904 266.5 404 266.5C397.096 266.5 391.5 272.096 391.5 279C391.5 285.904 397.096 291.5 404 291.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443 225C456.807 225 468 213.807 468 200C468 186.193 456.807 175 443 175C429.193 175 418 186.193 418 200C418 213.807 429.193 225 443 225ZM443 212.5C449.904 212.5 455.5 206.904 455.5 200C455.5 193.096 449.904 187.5 443 187.5C436.096 187.5 430.5 193.096 430.5 200C430.5 206.904 436.096 212.5 443 212.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M496 166C509.807 166 521 154.807 521 141C521 127.193 509.807 116 496 116C482.193 116 471 127.193 471 141C471 154.807 482.193 166 496 166ZM496 153.5C502.904 153.5 508.5 147.904 508.5 141C508.5 134.096 502.904 128.5 496 128.5C489.096 128.5 483.5 134.096 483.5 141C483.5 147.904 489.096 153.5 496 153.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1054 522C1067.81 522 1079 510.807 1079 497C1079 483.193 1067.81 472 1054 472C1040.19 472 1029 483.193 1029 497C1029 510.807 1040.19 522 1054 522ZM1054 509.5C1060.9 509.5 1066.5 503.904 1066.5 497C1066.5 490.096 1060.9 484.5 1054 484.5C1047.1 484.5 1041.5 490.096 1041.5 497C1041.5 503.904 1047.1 509.5 1054 509.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M482 836C495.807 836 507 824.807 507 811C507 797.193 495.807 786 482 786C468.193 786 457 797.193 457 811C457 824.807 468.193 836 482 836ZM482 823.5C488.904 823.5 494.5 817.904 494.5 811C494.5 804.096 488.904 798.5 482 798.5C475.096 798.5 469.5 804.096 469.5 811C469.5 817.904 475.096 823.5 482 823.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888 915C901.807 915 913 903.807 913 890C913 876.193 901.807 865 888 865C874.193 865 863 876.193 863 890C863 903.807 874.193 915 888 915ZM888 902.5C894.904 902.5 900.5 896.904 900.5 890C900.5 883.096 894.904 877.5 888 877.5C881.096 877.5 875.5 883.096 875.5 890C875.5 896.904 881.096 902.5 888 902.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1016 219C1029.81 219 1041 207.807 1041 194C1041 180.193 1029.81 169 1016 169C1002.19 169 991 180.193 991 194C991 207.807 1002.19 219 1016 219ZM1016 206.5C1022.9 206.5 1028.5 200.904 1028.5 194C1028.5 187.096 1022.9 181.5 1016 181.5C1009.1 181.5 1003.5 187.096 1003.5 194C1003.5 200.904 1009.1 206.5 1016 206.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M558 502C571.807 502 583 490.807 583 477C583 463.193 571.807 452 558 452C544.193 452 533 463.193 533 477C533 490.807 544.193 502 558 502ZM558 489.5C564.904 489.5 570.5 483.904 570.5 477C570.5 470.096 564.904 464.5 558 464.5C551.096 464.5 545.5 470.096 545.5 477C545.5 483.904 551.096 489.5 558 489.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383 374C396.807 374 408 362.807 408 349C408 335.193 396.807 324 383 324C369.193 324 358 335.193 358 349C358 362.807 369.193 374 383 374ZM383 361.5C389.904 361.5 395.5 355.904 395.5 349C395.5 342.096 389.904 336.5 383 336.5C376.096 336.5 370.5 342.096 370.5 349C370.5 355.904 376.096 361.5 383 361.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312 464C325.807 464 337 452.807 337 439C337 425.193 325.807 414 312 414C298.193 414 287 425.193 287 439C287 452.807 298.193 464 312 464ZM312 451.5C318.904 451.5 324.5 445.904 324.5 439C324.5 432.096 318.904 426.5 312 426.5C305.096 426.5 299.5 432.096 299.5 439C299.5 445.904 305.096 451.5 312 451.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319 385C332.807 385 344 373.807 344 360C344 346.193 332.807 335 319 335C305.193 335 294 346.193 294 360C294 373.807 305.193 385 319 385ZM319 372.5C325.904 372.5 331.5 366.904 331.5 360C331.5 353.096 325.904 347.5 319 347.5C312.096 347.5 306.5 353.096 306.5 360C306.5 366.904 312.096 372.5 319 372.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345 320C358.807 320 370 308.807 370 295C370 281.193 358.807 270 345 270C331.193 270 320 281.193 320 295C320 308.807 331.193 320 345 320ZM345 307.5C351.904 307.5 357.5 301.904 357.5 295C357.5 288.096 351.904 282.5 345 282.5C338.096 282.5 332.5 288.096 332.5 295C332.5 301.904 338.096 307.5 345 307.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M379 238C392.807 238 404 226.807 404 213C404 199.193 392.807 188 379 188C365.193 188 354 199.193 354 213C354 226.807 365.193 238 379 238ZM379 225.5C385.904 225.5 391.5 219.904 391.5 213C391.5 206.096 385.904 200.5 379 200.5C372.096 200.5 366.5 206.096 366.5 213C366.5 219.904 372.096 225.5 379 225.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424 166C437.807 166 449 154.807 449 141C449 127.193 437.807 116 424 116C410.193 116 399 127.193 399 141C399 154.807 410.193 166 424 166ZM424 153.5C430.904 153.5 436.5 147.904 436.5 141C436.5 134.096 430.904 128.5 424 128.5C417.096 128.5 411.5 134.096 411.5 141C411.5 147.904 417.096 153.5 424 153.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M468 113C481.807 113 493 101.807 493 88C493 74.1929 481.807 63 468 63C454.193 63 443 74.1929 443 88C443 101.807 454.193 113 468 113ZM468 100.5C474.904 100.5 480.5 94.9036 480.5 88C480.5 81.0964 474.904 75.5 468 75.5C461.096 75.5 455.5 81.0964 455.5 88C455.5 94.9036 461.096 100.5 468 100.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M528 81C541.807 81 553 69.8071 553 56C553 42.1929 541.807 31 528 31C514.193 31 503 42.1929 503 56C503 69.8071 514.193 81 528 81ZM528 68.5C534.904 68.5 540.5 62.9036 540.5 56C540.5 49.0964 534.904 43.5 528 43.5C521.096 43.5 515.5 49.0964 515.5 56C515.5 62.9036 521.096 68.5 528 68.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M992 541C1005.81 541 1017 529.807 1017 516C1017 502.193 1005.81 491 992 491C978.193 491 967 502.193 967 516C967 529.807 978.193 541 992 541ZM992 528.5C998.904 528.5 1004.5 522.904 1004.5 516C1004.5 509.096 998.904 503.5 992 503.5C985.096 503.5 979.5 509.096 979.5 516C979.5 522.904 985.096 528.5 992 528.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416 863C429.807 863 441 851.807 441 838C441 824.193 429.807 813 416 813C402.193 813 391 824.193 391 838C391 851.807 402.193 863 416 863ZM416 850.5C422.904 850.5 428.5 844.904 428.5 838C428.5 831.096 422.904 825.5 416 825.5C409.096 825.5 403.5 831.096 403.5 838C403.5 844.904 409.096 850.5 416 850.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827 928C840.807 928 852 916.807 852 903C852 889.193 840.807 878 827 878C813.193 878 802 889.193 802 903C802 916.807 813.193 928 827 928ZM827 915.5C833.904 915.5 839.5 909.904 839.5 903C839.5 896.096 833.904 890.5 827 890.5C820.096 890.5 814.5 896.096 814.5 903C814.5 909.904 820.096 915.5 827 915.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M966 288C979.807 288 991 276.807 991 263C991 249.193 979.807 238 966 238C952.193 238 941 249.193 941 263C941 276.807 952.193 288 966 288ZM966 275.5C972.904 275.5 978.5 269.904 978.5 263C978.5 256.096 972.904 250.5 966 250.5C959.096 250.5 953.5 256.096 953.5 263C953.5 269.904 959.096 275.5 966 275.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M689 431C702.807 431 714 419.807 714 406C714 392.193 702.807 381 689 381C675.193 381 664 392.193 664 406C664 419.807 675.193 431 689 431ZM689 418.5C695.904 418.5 701.5 412.904 701.5 406C701.5 399.096 695.904 393.5 689 393.5C682.096 393.5 676.5 399.096 676.5 406C676.5 412.904 682.096 418.5 689 418.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1124 481C1137.81 481 1149 469.807 1149 456C1149 442.193 1137.81 431 1124 431C1110.19 431 1099 442.193 1099 456C1099 469.807 1110.19 481 1124 481ZM1124 468.5C1130.9 468.5 1136.5 462.904 1136.5 456C1136.5 449.096 1130.9 443.5 1124 443.5C1117.1 443.5 1111.5 449.096 1111.5 456C1111.5 462.904 1117.1 468.5 1124 468.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1086 389C1099.81 389 1111 377.807 1111 364C1111 350.193 1099.81 339 1086 339C1072.19 339 1061 350.193 1061 364C1061 377.807 1072.19 389 1086 389ZM1086 376.5C1092.9 376.5 1098.5 370.904 1098.5 364C1098.5 357.096 1092.9 351.5 1086 351.5C1079.1 351.5 1073.5 357.096 1073.5 364C1073.5 370.904 1079.1 376.5 1086 376.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1151 417C1164.81 417 1176 405.807 1176 392C1176 378.193 1164.81 367 1151 367C1137.19 367 1126 378.193 1126 392C1126 405.807 1137.19 417 1151 417ZM1151 404.5C1157.9 404.5 1163.5 398.904 1163.5 392C1163.5 385.096 1157.9 379.5 1151 379.5C1144.1 379.5 1138.5 385.096 1138.5 392C1138.5 398.904 1144.1 404.5 1151 404.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1153 350C1166.81 350 1178 338.807 1178 325C1178 311.193 1166.81 300 1153 300C1139.19 300 1128 311.193 1128 325C1128 338.807 1139.19 350 1153 350ZM1153 337.5C1159.9 337.5 1165.5 331.904 1165.5 325C1165.5 318.096 1159.9 312.5 1153 312.5C1146.1 312.5 1140.5 318.096 1140.5 325C1140.5 331.904 1146.1 337.5 1153 337.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1206 302C1219.81 302 1231 290.807 1231 277C1231 263.193 1219.81 252 1206 252C1192.19 252 1181 263.193 1181 277C1181 290.807 1192.19 302 1206 302ZM1206 289.5C1212.9 289.5 1218.5 283.904 1218.5 277C1218.5 270.096 1212.9 264.5 1206 264.5C1199.1 264.5 1193.5 270.096 1193.5 277C1193.5 283.904 1199.1 289.5 1206 289.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1146 277C1159.81 277 1171 265.807 1171 252C1171 238.193 1159.81 227 1146 227C1132.19 227 1121 238.193 1121 252C1121 265.807 1132.19 277 1146 277ZM1146 264.5C1152.9 264.5 1158.5 258.904 1158.5 252C1158.5 245.096 1152.9 239.5 1146 239.5C1139.1 239.5 1133.5 245.096 1133.5 252C1133.5 258.904 1139.1 264.5 1146 264.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1136 200C1149.81 200 1161 188.807 1161 175C1161 161.193 1149.81 150 1136 150C1122.19 150 1111 161.193 1111 175C1111 188.807 1122.19 200 1136 200ZM1136 187.5C1142.9 187.5 1148.5 181.904 1148.5 175C1148.5 168.096 1142.9 162.5 1136 162.5C1129.1 162.5 1123.5 168.096 1123.5 175C1123.5 181.904 1129.1 187.5 1136 187.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1119 136C1132.81 136 1144 124.807 1144 111C1144 97.1929 1132.81 86 1119 86C1105.19 86 1094 97.1929 1094 111C1094 124.807 1105.19 136 1119 136ZM1119 123.5C1125.9 123.5 1131.5 117.904 1131.5 111C1131.5 104.096 1125.9 98.5 1119 98.5C1112.1 98.5 1106.5 104.096 1106.5 111C1106.5 117.904 1112.1 123.5 1119 123.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547 792C560.807 792 572 780.807 572 767C572 753.193 560.807 742 547 742C533.193 742 522 753.193 522 767C522 780.807 533.193 792 547 792ZM547 779.5C553.904 779.5 559.5 773.904 559.5 767C559.5 760.096 553.904 754.5 547 754.5C540.096 754.5 534.5 760.096 534.5 767C534.5 773.904 540.096 779.5 547 779.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949 883C962.807 883 974 871.807 974 858C974 844.193 962.807 833 949 833C935.193 833 924 844.193 924 858C924 871.807 935.193 883 949 883ZM949 870.5C955.904 870.5 961.5 864.904 961.5 858C961.5 851.096 955.904 845.5 949 845.5C942.096 845.5 936.5 851.096 936.5 858C936.5 864.904 942.096 870.5 949 870.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1070 173C1083.81 173 1095 161.807 1095 148C1095 134.193 1083.81 123 1070 123C1056.19 123 1045 134.193 1045 148C1045 161.807 1056.19 173 1070 173ZM1070 160.5C1076.9 160.5 1082.5 154.904 1082.5 148C1082.5 141.096 1076.9 135.5 1070 135.5C1063.1 135.5 1057.5 141.096 1057.5 148C1057.5 154.904 1063.1 160.5 1070 160.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M750 258C763.807 258 775 246.807 775 233C775 219.193 763.807 208 750 208C736.193 208 725 219.193 725 233C725 246.807 736.193 258 750 258ZM750 245.5C756.904 245.5 762.5 239.904 762.5 233C762.5 226.096 756.904 220.5 750 220.5C743.096 220.5 737.5 226.096 737.5 233C737.5 239.904 743.096 245.5 750 245.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M725 199C738.807 199 750 187.807 750 174C750 160.193 738.807 149 725 149C711.193 149 700 160.193 700 174C700 187.807 711.193 199 725 199ZM725 186.5C731.904 186.5 737.5 180.904 737.5 174C737.5 167.096 731.904 161.5 725 161.5C718.096 161.5 712.5 167.096 712.5 174C712.5 180.904 718.096 186.5 725 186.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647 191C660.807 191 672 179.807 672 166C672 152.193 660.807 141 647 141C633.193 141 622 152.193 622 166C622 179.807 633.193 191 647 191ZM647 178.5C653.904 178.5 659.5 172.904 659.5 166C659.5 159.096 653.904 153.5 647 153.5C640.096 153.5 634.5 159.096 634.5 166C634.5 172.904 640.096 178.5 647 178.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M697 127C710.807 127 722 115.807 722 102C722 88.1929 710.807 77 697 77C683.193 77 672 88.1929 672 102C672 115.807 683.193 127 697 127ZM697 114.5C703.904 114.5 709.5 108.904 709.5 102C709.5 95.0964 703.904 89.5 697 89.5C690.096 89.5 684.5 95.0964 684.5 102C684.5 108.904 690.096 114.5 697 114.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M846 123C859.807 123 871 111.807 871 98C871 84.1929 859.807 73 846 73C832.193 73 821 84.1929 821 98C821 111.807 832.193 123 846 123ZM846 110.5C852.904 110.5 858.5 104.904 858.5 98C858.5 91.0964 852.904 85.5 846 85.5C839.096 85.5 833.5 91.0964 833.5 98C833.5 104.904 839.096 110.5 846 110.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M908 88C921.807 88 933 76.8071 933 63C933 49.1929 921.807 38 908 38C894.193 38 883 49.1929 883 63C883 76.8071 894.193 88 908 88ZM908 75.5C914.904 75.5 920.5 69.9036 920.5 63C920.5 56.0964 914.904 50.5 908 50.5C901.096 50.5 895.5 56.0964 895.5 63C895.5 69.9036 901.096 75.5 908 75.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M921 152C934.807 152 946 140.807 946 127C946 113.193 934.807 102 921 102C907.193 102 896 113.193 896 127C896 140.807 907.193 152 921 152ZM921 139.5C927.904 139.5 933.5 133.904 933.5 127C933.5 120.096 927.904 114.5 921 114.5C914.096 114.5 908.5 120.096 908.5 127C908.5 133.904 914.096 139.5 921 139.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M949 210C962.807 210 974 198.807 974 185C974 171.193 962.807 160 949 160C935.193 160 924 171.193 924 185C924 198.807 935.193 210 949 210ZM949 197.5C955.904 197.5 961.5 191.904 961.5 185C961.5 178.096 955.904 172.5 949 172.5C942.096 172.5 936.5 178.096 936.5 185C936.5 191.904 942.096 197.5 949 197.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M608 131C621.807 131 633 119.807 633 106C633 92.1929 621.807 81 608 81C594.193 81 583 92.1929 583 106C583 119.807 594.193 131 608 131ZM608 118.5C614.904 118.5 620.5 112.904 620.5 106C620.5 99.0964 614.904 93.5 608 93.5C601.096 93.5 595.5 99.0964 595.5 106C595.5 112.904 601.096 118.5 608 118.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834 403C847.807 403 859 391.807 859 378C859 364.193 847.807 353 834 353C820.193 353 809 364.193 809 378C809 391.807 820.193 403 834 403ZM834 390.5C840.904 390.5 846.5 384.904 846.5 378C846.5 371.096 840.904 365.5 834 365.5C827.096 365.5 821.5 371.096 821.5 378C821.5 384.904 827.096 390.5 834 390.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M831 477C844.807 477 856 465.807 856 452C856 438.193 844.807 427 831 427C817.193 427 806 438.193 806 452C806 465.807 817.193 477 831 477ZM831 464.5C837.904 464.5 843.5 458.904 843.5 452C843.5 445.096 837.904 439.5 831 439.5C824.096 439.5 818.5 445.096 818.5 452C818.5 458.904 824.096 464.5 831 464.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M830 251C843.807 251 855 239.807 855 226C855 212.193 843.807 201 830 201C816.193 201 805 212.193 805 226C805 239.807 816.193 251 830 251ZM830 238.5C836.904 238.5 842.5 232.904 842.5 226C842.5 219.096 836.904 213.5 830 213.5C823.096 213.5 817.5 219.096 817.5 226C817.5 232.904 823.096 238.5 830 238.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790 194C803.807 194 815 182.807 815 169C815 155.193 803.807 144 790 144C776.193 144 765 155.193 765 169C765 182.807 776.193 194 790 194ZM790 181.5C796.904 181.5 802.5 175.904 802.5 169C802.5 162.096 796.904 156.5 790 156.5C783.096 156.5 777.5 162.096 777.5 169C777.5 175.904 783.096 181.5 790 181.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775 127C788.807 127 800 115.807 800 102C800 88.1929 788.807 77 775 77C761.193 77 750 88.1929 750 102C750 115.807 761.193 127 775 127ZM775 114.5C781.904 114.5 787.5 108.904 787.5 102C787.5 95.0964 781.904 89.5 775 89.5C768.096 89.5 762.5 95.0964 762.5 102C762.5 108.904 768.096 114.5 775 114.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M743 72C756.807 72 768 60.8071 768 47C768 33.1929 756.807 22 743 22C729.193 22 718 33.1929 718 47C718 60.8071 729.193 72 743 72ZM743 59.5C749.904 59.5 755.5 53.9036 755.5 47C755.5 40.0964 749.904 34.5 743 34.5C736.096 34.5 730.5 40.0964 730.5 47C730.5 53.9036 736.096 59.5 743 59.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822 67C835.807 67 847 55.8071 847 42C847 28.1929 835.807 17 822 17C808.193 17 797 28.1929 797 42C797 55.8071 808.193 67 822 67ZM822 54.5C828.904 54.5 834.5 48.9036 834.5 42C834.5 35.0964 828.904 29.5 822 29.5C815.096 29.5 809.5 35.0964 809.5 42C809.5 48.9036 815.096 54.5 822 54.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M647 80C660.807 80 672 68.8071 672 55C672 41.1929 660.807 30 647 30C633.193 30 622 41.1929 622 55C622 68.8071 633.193 80 647 80ZM647 67.5C653.904 67.5 659.5 61.9036 659.5 55C659.5 48.0964 653.904 42.5 647 42.5C640.096 42.5 634.5 48.0964 634.5 55C634.5 61.9036 640.096 67.5 647 67.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M578 199C591.807 199 603 187.807 603 174C603 160.193 591.807 149 578 149C564.193 149 553 160.193 553 174C553 187.807 564.193 199 578 199ZM578 186.5C584.904 186.5 590.5 180.904 590.5 174C590.5 167.096 584.904 161.5 578 161.5C571.096 161.5 565.5 167.096 565.5 174C565.5 180.904 571.096 186.5 578 186.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M905 389C918.807 389 930 377.807 930 364C930 350.193 918.807 339 905 339C891.193 339 880 350.193 880 364C880 377.807 891.193 389 905 389ZM905 376.5C911.904 376.5 917.5 370.904 917.5 364C917.5 357.096 911.904 351.5 905 351.5C898.096 351.5 892.5 357.096 892.5 364C892.5 370.904 898.096 376.5 905 376.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M954 428C967.807 428 979 416.807 979 403C979 389.193 967.807 378 954 378C940.193 378 929 389.193 929 403C929 416.807 940.193 428 954 428ZM954 415.5C960.904 415.5 966.5 409.904 966.5 403C966.5 396.096 960.904 390.5 954 390.5C947.096 390.5 941.5 396.096 941.5 403C941.5 409.904 947.096 415.5 954 415.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M891 450C904.807 450 916 438.807 916 425C916 411.193 904.807 400 891 400C877.193 400 866 411.193 866 425C866 438.807 877.193 450 891 450ZM891 437.5C897.904 437.5 903.5 431.904 903.5 425C903.5 418.096 897.904 412.5 891 412.5C884.096 412.5 878.5 418.096 878.5 425C878.5 431.904 884.096 437.5 891 437.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M884 528C897.807 528 909 516.807 909 503C909 489.193 897.807 478 884 478C870.193 478 859 489.193 859 503C859 516.807 870.193 528 884 528ZM884 515.5C890.904 515.5 896.5 509.904 896.5 503C896.5 496.096 890.904 490.5 884 490.5C877.096 490.5 871.5 496.096 871.5 503C871.5 509.904 877.096 515.5 884 515.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904 251C917.807 251 929 239.807 929 226C929 212.193 917.807 201 904 201C890.193 201 879 212.193 879 226C879 239.807 890.193 251 904 251ZM904 238.5C910.904 238.5 916.5 232.904 916.5 226C916.5 219.096 910.904 213.5 904 213.5C897.096 213.5 891.5 219.096 891.5 226C891.5 232.904 897.096 238.5 904 238.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M860 185C873.807 185 885 173.807 885 160C885 146.193 873.807 135 860 135C846.193 135 835 146.193 835 160C835 173.807 846.193 185 860 185ZM860 172.5C866.904 172.5 872.5 166.904 872.5 160C872.5 153.096 866.904 147.5 860 147.5C853.096 147.5 847.5 153.096 847.5 160C847.5 166.904 853.096 172.5 860 172.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M583 352C596.807 352 608 340.807 608 327C608 313.193 596.807 302 583 302C569.193 302 558 313.193 558 327C558 340.807 569.193 352 583 352ZM583 339.5C589.904 339.5 595.5 333.904 595.5 327C595.5 320.096 589.904 314.5 583 314.5C576.096 314.5 570.5 320.096 570.5 327C570.5 333.904 576.096 339.5 583 339.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M679 260C692.807 260 704 248.807 704 235C704 221.193 692.807 210 679 210C665.193 210 654 221.193 654 235C654 248.807 665.193 260 679 260ZM679 247.5C685.904 247.5 691.5 241.904 691.5 235C691.5 228.097 685.904 222.5 679 222.5C672.096 222.5 666.5 228.097 666.5 235C666.5 241.904 672.096 247.5 679 247.5Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614 203.787C627.807 203.787 639 214.98 639 228.787C639 229.631 638.958 230.464 638.877 231.287C638.651 233.556 639.791 254.737 639 256.787H626.5C626.961 255.847 626.036 232.341 626.25 231.287C626.414 230.479 626.5 229.643 626.5 228.787C626.5 221.883 620.904 216.287 614 216.287C607.096 216.287 601.5 221.883 601.5 228.787C601.5 235.69 607.096 241.287 614 241.287C623.5 241.287 626.25 234.287 626.5 228.787H638.877C639 246.287 625.612 253.787 614 253.787C600.193 253.787 589 242.594 589 228.787C589 214.98 600.193 203.787 614 203.787Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639 256.787H626.5C626.5 264.287 624.5 269 614.5 269C604.5 269 603.5 261.5 603.5 261.5C603.5 261.5 603.5 256.5 598 256.5C592.5 256.5 592 261.5 592 261.5C592 266.5 598.5 279.5 614.5 279C630.5 278.5 639.5 269.287 639 256.787Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936 311C936 317.738 936 325 936 325C936 325 935 330.5 930 330.5C925 330.5 923.5 325 923.5 325C923.5 319.921 923.5 312.886 923.5 311C923.5 304.097 917.904 298.5 911 298.5C904.096 298.5 898.5 304.097 898.5 311C898.5 313.171 898.5 320.03 898.5 325C898.5 325 898 330.5 892 330.5C886 330.5 886 325 886 325C886 325 886 318.885 886 311C886 306.447 886 298.5 886 298.5L886 286L886 270C886 270 886.5 265 892 265C897.5 265 898.5 270 898.5 270V286V290C898.5 290 901.5 286 911 286C924.807 286 936 297.193 936 311Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M798 311C798 317.738 798 325 798 325C798 325 797 330.5 792 330.5C787 330.5 785.5 325 785.5 325C785.5 319.921 785.5 312.886 785.5 311C785.5 304.097 779.904 298.5 773 298.5C766.096 298.5 760.5 304.097 760.5 311C760.5 313.171 760.5 320.03 760.5 325C760.5 325 760 330.5 754 330.5C748 330.5 748 325 748 325C748 325 748 318.885 748 311C748 306.447 748 298.5 748 298.5L748 286L748 270C748 270 748.5 265 754 265C759.5 265 760.5 270 760.5 270V286V290C760.5 290 763.5 286 773 286C786.807 286 798 297.193 798 311Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M712 331C725.807 331 737 319.807 737 306C737 292.193 725.807 281 712 281C698.193 281 687 292.193 687 306V329L687 352C687 352 688 358 694 358C700 358 699 351 699 351V327.5C702.013 328.788 708.516 331 712 331ZM712 318.5C718.904 318.5 724.5 312.904 724.5 306C724.5 299.097 718.904 293.5 712 293.5C705.097 293.5 699.5 299.097 699.5 306C699.5 312.904 705.097 318.5 712 318.5Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.013 273C867.505 273 874.5 283.653 874.5 288.71C874.5 288.71 874 293.5 869.5 293.5C865 293.5 864.006 288.71 864.006 288.71C864.006 288.71 862.008 283.5 856.013 283.5C850.017 283.5 848.5 287.5 848.5 290.5C848.5 293.5 852.025 296 856.013 296.5C860 297 866.5 299.79 869 302C871.5 304.21 874 308.5 874 314.911C874 321.323 869 332.5 856.013 332C843.025 331.5 838.525 324.105 838.025 315.831C838.025 315.831 838.544 310.807 843.522 311.153C848.5 311.5 849.019 315.831 849.019 315.831C849.019 315.831 849.517 320.5 856.013 320.5C862.508 320.5 864.006 316.75 864.006 314.911C864.006 313.073 864.507 307.637 856.013 307.637C851.381 307.637 845.993 305.91 842.522 302.581C839.627 299.803 838.252 294.771 838.025 291.008C837.525 282.734 844.521 273 856.013 273Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819,
    cy: 277,
    r: 6,
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813 325V295C813 295 813.5 291 819 291C824.5 291 824.5 295 824.5 295V325C824.5 325 823.5 329 818.5 329C813.5 329 813 325 813 325Z",
    fill: "#D06767"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M941 497C954.807 497 966 485.807 966 472C966 458.193 954.807 447 941 447C927.193 447 916 458.193 916 472C916 485.807 927.193 497 941 497ZM941 484.5C947.904 484.5 953.5 478.904 953.5 472C953.5 465.096 947.904 459.5 941 459.5C934.096 459.5 928.5 465.096 928.5 472C928.5 478.904 934.096 484.5 941 484.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M946 1020C959.807 1020 971 1008.81 971 995C971 981.193 959.807 970 946 970C932.193 970 921 981.193 921 995C921 1008.81 932.193 1020 946 1020ZM946 1007.5C952.904 1007.5 958.5 1001.9 958.5 995C958.5 988.096 952.904 982.5 946 982.5C939.096 982.5 933.5 988.096 933.5 995C933.5 1001.9 939.096 1007.5 946 1007.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M705 982C718.807 982 730 970.807 730 957C730 943.193 718.807 932 705 932C691.193 932 680 943.193 680 957C680 970.807 691.193 982 705 982ZM705 969.5C711.904 969.5 717.5 963.904 717.5 957C717.5 950.096 711.904 944.5 705 944.5C698.096 944.5 692.5 950.096 692.5 957C692.5 963.904 698.096 969.5 705 969.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M602 906C615.807 906 627 894.807 627 881C627 867.193 615.807 856 602 856C588.193 856 577 867.193 577 881C577 894.807 588.193 906 602 906ZM602 893.5C608.904 893.5 614.5 887.904 614.5 881C614.5 874.096 608.904 868.5 602 868.5C595.096 868.5 589.5 874.096 589.5 881C589.5 887.904 595.096 893.5 602 893.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M639 965C652.807 965 664 953.807 664 940C664 926.193 652.807 915 639 915C625.193 915 614 926.193 614 940C614 953.807 625.193 965 639 965ZM639 952.5C645.904 952.5 651.5 946.904 651.5 940C651.5 933.096 645.904 927.5 639 927.5C632.096 927.5 626.5 933.096 626.5 940C626.5 946.904 632.096 952.5 639 952.5Z",
    fill: "#E27676",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_568_260"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1512,
    height: 982,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.13f37b89d6ab3219768dba6b0ee74848.svg";
export { ForwardRef as ReactComponent };